module.exports = __webpack_public_path__ + "img/quest_icon_0032_grid.5ab81e08.png";